// SortContent.js

import React, { useState, useEffect } from 'react';
import { Radio, Divider, Button } from 'antd';
import {
  SortAscendingOutlined,
  SortDescendingOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const MilestoneSortContent = ({
  sortOrder,
  handleSortOrderChange,
  sortField,
  handleSortChange,
}) => {
  const [isClearVisible, setIsClearVisible] = useState(false);

  const handleClear = () => {
    handleSortChange('None');
  };

  useEffect(() => {
    setIsClearVisible(sortField !== 'None' && sortField !== null && sortOrder !== null);
  }, [sortField, sortOrder]);
  return (
    <>
      <div style={{ marginBottom: '10px', position: 'fixed' }}>
        <Radio.Group value={sortOrder} onChange={handleSortOrderChange}>
          <Radio value="asc" checked>
            <SortAscendingOutlined />
            Ascending
          </Radio>
          <Radio value="desc">
            <SortDescendingOutlined />
            Descending
          </Radio>
        </Radio.Group>
      </div>
      <Divider style={{ margin: '10px 0' }} />
      <div
        style={{
          padding: '10px',
          maxHeight: '500px',
          overflowY: 'auto',
          backgroundColor: 'whitesmoke',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          {isClearVisible && (
            <Button
              type="text"
              onClick={handleClear}
              style={{ padding: 0, color: 'blue' }}
              icon={<CloseCircleOutlined />}
            >
              Clear
            </Button>
          )}
        </div>
        <div style={{ marginTop: '50px' }}>
          <Radio.Group onChange={(e) => handleSortChange(e.target.value)} value={sortField}>
            <div>
              <Radio value="None">None</Radio>
            </div>
            <div>
              <Radio value="milestoneNumber">#</Radio>
            </div>
            <div>
              <Radio value="name">Name</Radio>
            </div>
            <div>
              <Radio value="# - Name"># - Name</Radio>
            </div>
            <div>
              <Radio value="Owner">Milestone owner</Radio>
            </div>
            <div>
              <Radio value="status">Status</Radio>
            </div>
            <div>
              <Radio value="type">Type</Radio>
            </div>
            <div>
              <Radio value="Work starting date">Work starting date</Radio>
            </div>
            <div>
              <Radio value="Milestone completion date">Milestone completion date</Radio>
            </div>
            <div>
              <Radio value="Change in Milestone completion date (binned, current vs last week)">
                Change in Milestone completion date (binned, current vs last week)
              </Radio>
            </div>
            <div>
              <Radio value="Planning summary (simplified)">Planning summary (simplified)</Radio>
            </div>
            <div>
              <Radio value="planningSummary">Planning summary</Radio>
            </div>
            <div>
              <Radio value="(LW) Planning summary">(LW) Planning summary</Radio>
            </div>
            <div>
              <Radio value="planningCheck">Planning check</Radio>
            </div>
            <div>
              <Radio value="Milestone Created on">Created on</Radio>
            </div>
            <div>
              <Radio value="Created by">Created by</Radio>
            </div>
            <div>
              <Radio value="Updated on">Updated on</Radio>
            </div>
            <div>
              <Radio value="Updated by">Updated by</Radio>
            </div>
          </Radio.Group>
        </div>
      </div>
    </>
  );
};

export default MilestoneSortContent;
